<template>
  <form @submit.prevent="handleSubmit">
    <b-field label="Issue">
      <issue-select v-model="form.issue_id"></issue-select>
    </b-field>
    
    <button class="button is-primary" :class="{'is-loading': form.processing}">Add</button>
  </form>
</template>

<script>
import IssueSelect from "../../../../components/selectors/IssueSelect";

export default {
  components: {
    IssueSelect
  },

  props: {
    campaignId: {
      require: true
    }
  },

  data() {
    return {
      form: new window.Form({
        issue_id: null
      })
    };
  },

  methods: {
    handleSubmit() {
      this.form
        .post("/admin/api/magazine/campaigns/" + this.campaignId + "/issue")
        .then(({ data }) => {
          this.$emit("added", data);
        });
    }
  }
};
</script>
